<div class="my-3 py-1" *ngIf="name === 'HELP'">
    <h6 mat-dialog-title>Help
        <button style="float: right;" mat-button mat-dialog-close>
            <i class="fa fa-times" aria-hidden="true"></i>
        </button>
    </h6>
    <div mat-dialog-content>
        <h2>Red Thread Quick Start Guide</h2>
        <br>
        <p>
            Using Red Thread Fit is as simple as following the three following steps:
        </p>
        <ol>
            <li>Enter your analysis parameters under the Analyze Report/Data tab</li>
            <li>Upload your input dataset as an Excel-formatted file</li>
            <li>Submit your analysis and download your output report</li>
        </ol>
        <p>
            To retrieve previous analytical data, navigate to the Previous Activities tab.
        </p>
        <h3>User Guide</h3>
        <p>
            For more information, including guidance on acceptable input formats, the effects of the
            different workflow parameters, and how to interpret the output file, please refer to the Red Thread Fit User
            Guide. If you do not have a copy of the latest user guide please reach out to us at
            <a href="mailto:support@bdatasolutions.com">support&#64;bdatasolutions.com</a>.
        </p>
    </div>
</div>